import { render, staticRenderFns } from "./AppC.vue?vue&type=template&id=5ee1de30&"
import script from "./AppC.vue?vue&type=script&lang=js&"
export * from "./AppC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports